var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { MdClose } from 'react-icons/md';
import { Box, Flex, Button, Text } from "./..";
import { getPaletteText } from "../../utils/paletteConversions";
var PRIMARY = 'primary';
var BannerContainer = function (_a) {
    var isOpen = _a.isOpen, _b = _a.palette, palette = _b === void 0 ? PRIMARY : _b, isSticky = _a.isSticky, children = _a.children, props = __rest(_a, ["isOpen", "palette", "isSticky", "children"]);
    var boxLss = {
        bg: palette,
        color: getPaletteText(palette),
        maxHeight: isOpen ? '100vh' : 0,
        transition: 'fast',
        transitionProperty: 'max-height',
        overflow: 'hidden',
        position: isSticky ? 'sticky' : undefined,
        top: isSticky ? 0 : undefined
    };
    return (React.createElement(Box, __assign({}, props, { lss: __assign(__assign({}, boxLss), props.lss) }), children));
};
export var Banner = function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? PRIMARY : _b, _c = _a.isDismissable, isDismissable = _c === void 0 ? false : _c, _d = _a.isSticky, isSticky = _d === void 0 ? false : _d, children = _a.children, onDismiss = _a.onDismiss, textLss = _a.textLss, props = __rest(_a, ["palette", "isDismissable", "isSticky", "children", "onDismiss", "textLss"]);
    var _e = __read(React.useState(true), 2), isOpen = _e[0], setIsOpen = _e[1];
    var handleDismiss = function () {
        if (onDismiss)
            onDismiss();
        setIsOpen(false);
    };
    var childrenLss = __assign({ flex: '1', mx: 'sm', my: 'none', p: 'md', textAlign: 'center', textScale: 'content' }, textLss);
    return (React.createElement(BannerContainer, __assign({ "aria-hidden": !isOpen, palette: palette, isOpen: isOpen, isSticky: isSticky }, props),
        React.createElement(Flex, { as: "aside", lss: {
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(Text, { lss: childrenLss }, children),
            isDismissable && (React.createElement(Button, { lss: {
                    borderRadius: 'rounded',
                    lineHeight: 1
                }, palette: palette, onClick: handleDismiss },
                React.createElement(MdClose, null))))));
};
//# sourceMappingURL=Banner.js.map